import React from 'react';
import { BadgeCheckIcon } from 'lucide-react';
interface QualiopiBadgeProps {
  tone?: 'light' | 'dark';
}
export function QualiopiBadge({
  tone = 'light'
}: QualiopiBadgeProps) {
  const isDark = tone === 'dark';
  return <div className={`inline-flex items-center gap-2.5 rounded-lg border px-3 py-2 ${isDark ? 'border-white/20 bg-white/5 text-white' : 'border-surface-line bg-white text-brand-800'}`} data-id="element-127" data-mp="s623gy4gg1s0">
      <BadgeCheckIcon size={18} className={isDark ? 'text-accent-400' : 'text-accent-500'} data-id="element-128" data-mp="jcyxtc01wt7x" />
      <span className="text-[13px] font-semibold leading-tight" data-id="element-129" data-mp="o6tb9xp2cbyk">
        Certifié Qualiopi
        <span className={`block text-[11px] font-normal ${isDark ? 'text-brand-200' : 'text-ink-faint'}`} data-id="element-130" data-mp="9hor4aypjxnt">
          Actions de formation
        </span>
      </span>
    </div>;
}